import { useNavigate } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import { useTranslation } from 'react-i18next';

function NavLink() {
    const { t } = useTranslation(); // Use t instead of lang
    const navigate = useNavigate();
 

    const handleClickNav = (e, url) => {
        e.preventDefault();
        navigate(url);
    }
    const nav = [
        { id: 1, name: 'Drivers', url: '/driver-list',secondPart :'driver'},
        { id: 1, name: 'Stores', url: '/stores-list',secondPart :'store' },
    ]
    const pathname = window.location.pathname;

    return (
        <Nav fill variant="pills" defaultActiveKey="/stores-list">
            {nav.map((item, index) => {
                return (
                    <Nav.Item key={index}>
                        <Nav.Link href={item.url}
                            active={pathname.indexOf(item.secondPart) !== -1}
                            onClick={(e) => handleClickNav(e, item.url)}>
                            {t(item.name)}
                        </Nav.Link>
                    </Nav.Item>
                )
            })}
        </Nav>
    );
}

export default NavLink;